import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";
import {
  MIDDLE_WARE_BASE_URL_v1,
  SAVE_USAGE_LOG,
} from "../../../utils/CONSTANTS";

const initialState = {
  saveUsageLogsState: "pending",
  saveUsageLogsData: null,
  saveUsageLogsMessage: "",
};

export const saveUsageLogs = createAsyncThunk(
  "post/saveUsageLogs",
  async (data: any) => {
    const response = axios.postRequest(
      MIDDLE_WARE_BASE_URL_v1() + SAVE_USAGE_LOG(),
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  }
);

const saveUsageLogsSlice = createSlice({
  name: "saveUsageLogs",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(saveUsageLogs.pending, (saveUsageLogsState) => {
        saveUsageLogsState.saveUsageLogsState = "pending";
      })
      .addCase(saveUsageLogs.fulfilled, (saveUsageLogsState, action) => {
        let tempRes = action.payload;
        if (typeof tempRes === "string") {
          tempRes = JSON.parse(tempRes);
        }

        saveUsageLogsState.saveUsageLogsState = "fulfilled";
        saveUsageLogsState.saveUsageLogsData = tempRes;
        saveUsageLogsState.saveUsageLogsMessage = tempRes
          ? tempRes?.message
          : "";
        //console.log("Insisde Slice ", tempRes);
      })
      .addCase(saveUsageLogs.rejected, (saveUsageLogsState) => {
        saveUsageLogsState.saveUsageLogsState = "failed";
      }),
});

export const saveUsageLogsDetails = (state: any) => state.saveUsageLogs;

export default saveUsageLogsSlice.reducer;
